import type { Currency } from '../services/cms'

const KEY = 'gm_pricing_currency'
const DEFAULT: Currency = 'EUR'

export function loadCurrency(): Currency {
  try {
    const v = localStorage.getItem(KEY)
    if (v === 'EUR' || v === 'USD' || v === 'SGD' || v === 'GBP') return v
  } catch {}
  return DEFAULT
}

export function saveCurrency(c: Currency): void {
  try { localStorage.setItem(KEY, c) } catch {}
}
